import { IconButton, Toolbar } from '@mui/material';
import React from 'react';
import AdminMenu from './AdminMenu';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userState } from '../../state/RecoilState';

import { drawerWidth } from '../../Constants';

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '& .MuiTypography-body1': {
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'uppercase',
    },
    '& .MuiListItemIcon-root': {
      minWidth: '40px',
      color: 'white',
    },
    backgroundColor: 'rgb(37, 45, 85)',
    color: 'white',
    borderRightColor: 'rgb(37, 45, 85)',
    '& .MuiToolbar-gutters': {
      backgroundColor: 'rgb(37, 45, 85)',
      //boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
      button: {
        color: 'white',
      },
    },
    hr: {
      borderColor: theme.palette.text.secondary,
    },
    boxSizing: 'border-box',
    ...(!open && {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      '& .MuiToolbar-gutters': {
        //boxShadow: 'none',
      },
    }),
  },
}));

interface Props {
  open: boolean;
  toggleDrawer: () => void;
}

const SideDrawer: React.FC<Props> = ({ open, toggleDrawer }) => {
  const navigate = useNavigate();
  const user = useRecoilValue<any>(userState);
  const onNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <Drawer
      variant='permanent'
      open={open}
      sx={{ minHeight: '100vh', '&.MuiDrawer-paper': { minWidth: 'unset' } }}
      className='side-bar-menu'
    >
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
        }}
      >
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      {user?.role === 'Administrator' && <AdminMenu onNavigate={onNavigate} />}
    </Drawer>
  );
};

export default SideDrawer;
